import { Component } from '@angular/core';

@Component({
    selector: 'insa-job-log',
    template: require('./insa-job-log.component.html')
})

export class JobLogComponent{
    public jobLogName: string = "ChronosJobLog";
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job-log/insa-job-log.component.ts